<template>
  <div class="feedbackInfo-page">
    <tabHeader
      :slideData="slideData"
      :tab="tab"
      @headerTabBack="headerTabBack"
    />
    <transition name="fade-transform" mode="out-in">
      <keep-alive>
        <component
          :is="tab"
          :refresh="refresh"
          v-if="imIsReady"
          @jumpToSessionList="jumpToSessionList"
        ></component>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import tabHeader from "@/components/tabHeader";
import sessionList from "./sessionList";
import blackList from "./blackList";
import statistics from "./statistics";
export default {
  components: {
    tabHeader,
    sessionList,
    blackList,
    statistics
  },
  computed: {
    ...mapGetters([
      "imMsgList",
      "imSessionList",
      "userInfo",
      "addPopup",
      "ctrlItem",
      "buckets"
    ]),
    slideData() {
      const slideData = [
        {
          name: "信息列表",
          component: "sessionList"
        },
        {
          name: "黑名单列表",
          component: "blackList"
        },
        {
          name: "统计",
          component: "statistics"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: "sessionList",
      imIsReady: false,
      refresh: false
    };
  },
  methods: {
    headerTabBack(tab) {
      this.$router.push({
        name: "feedbackInfo"
      });
      this.tab = tab.component;
      this.refresh = new Date().getTime();
    },
    async getSig() {
      let res = await this.$http.getSig({ user: "feedback" });
      await this.$tim.loginIM("feedback", res.data.sig);
      this.$tim.onEvn("SDK_READY", this.sdkReady);
    },

    jumpToSessionList(data) {
      this.tab = "sessionList";
      this.$router.push({
        name: "feedbackInfo",
        query: { from: data.from, MsgKey: data.MsgKey }
      });
    },

    // ==================== 初始化IM =======================
    async sdkReady({ name }) {
      if (name === "sdkStateReady") {
        this.imIsReady = true;
        this.$tim.onEvn("MESSAGE_RECEIVED", this.msgReceived);
        this.$tim.onEvn(
          "CONVERSATION_LIST_UPDATED",
          this.conversationListUpdate
        );
      }
    },

    async msgReceived(evn) {
      // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
      // event.name - TIM.EVENT.MESSAGE_RECEIVED
      // event.data - 存储 Message 对象的数组 - [Message]
      if (
        this.ctrlItem &&
        this.ctrlItem.conversationID === evn.data[0].conversationID
      ) {
        let msgList = [
          ...this.imMsgList,
          ...evn.data.filter(item => !item.isRevoked)
        ];
        this.$store.dispatch("updateMsgList", msgList);
      }
    },
    async conversationListUpdate(evn) {
      // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
      this.updateConversationList(evn.data);
    },

    updateConversationList(data) {
      let sessionList = data.filter(
        item => item.userProfile.userID !== "feedback"
      );
      this.$store.dispatch("updateSessionList", sessionList);
    }
  },

  destroyed() {
    this.$tim.offEvn("SDK_READY", this.sdkReady);
    this.$tim.offEvn("MESSAGE_RECEIVED", this.msgReceived);
    this.$tim.offEvn("CONVERSATION_LIST_UPDATED", this.conversationListUpdate);
    this.$tim.logoutIM();
  },
  created() {
    this.getSig();
  }
};
</script>

<style lang="scss">
.feedbackInfo-page {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
